import formatPhoneNumber from "./formatPhoneNumber";
export default (numberString) => formatPhoneNumber(numberString, {countryCode: 372});
